import React from 'react';
import { NumberInput } from 'react-admin';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import { InputAdornment } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiTextField-root': {
      width: '100%',
    },
    '& .MuiFilledInput-root': {
      backgroundColor: '#fdfdfd',
    },
    '& .MuiFormHelperText-contained': {
      display: 'none',
    },
  },
  listLabel: {
    fontWeight: '600',
    color: '#637381',
    marginTop: 20,
  },
  flexEnd: {
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  textRight: {
    textAlign: 'right',
  },
}));

const UnifiedEditPaid = ({ amount_paid_dollars }) => {
  const classes = useStyles();
  return (
    <>
    <TableCell colSpan={3}></TableCell>
    <TableCell colSpan={9}>
      <Grid container spacing={1} className={classes.root}>
        <Grid item md={3} sm={3} xs={12}>
          <Typography
            variant="body1"
            gutterBottom
            className={classes.listLabel}
          >
            Paid
          </Typography>
        </Grid>

        <Grid item md={9} sm={9} xs={12}>
          <Grid
            container
            spacing={1}
            className={`${classes.root} ${classes.flexEnd} schedule_work_section`}
          >
            <Grid item md={6} sm={6} xs={12}>
              <NumberInput
                source="amount_paid_dollars"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item md={2} sm={2} xs={12} className={classes.textRight}>
              {amount_paid_dollars}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </TableCell>
    </>
  );
};

export default UnifiedEditPaid;
